import { vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["type", "name", "value", "disabled"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["data-selected"]
const _hoisted_4 = { class: "gfu-field-toggle__label-text" }
const _hoisted_5 = ["data-qa"]
const _hoisted_6 = {
  key: 0,
  class: "gfu-field-toggle__label-text"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _mergeProps({..._ctx.$attrs, ..._ctx.$props}, {
    "show-label": !$props.condensed && $props.showLabel
  }), {
    default: _withCtx(() => [
      _createElementVNode("label", {
        class: _normalizeClass([
            'gfu-field__toggle gfu-field-toggle',
            `gfu-field-toggle--${$props.type}`,
            $props.labelClass
        ])
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model) = $event)),
          class: "gfu-field-toggle__input",
          type: $props.type,
          name: _ctx.name,
          value: $props.checkedValue,
          disabled: $options.isDisabled,
          "data-qa": `checkbox-input`
        }, null, 8 /* PROPS */, _hoisted_1), [
          [_vModelDynamic, _ctx.model]
        ]),
        _createElementVNode("div", {
          role: "button",
          class: _normalizeClass([
                     'gfu-field-toggle__label',
                     { 'gfu-field-toggle__label--disabled': _ctx.disabled},
                     { 'gfu-field-toggle--readonly': _ctx.readOnly }
                 ]),
          "aria-label": _ctx.name
        }, [
          _createElementVNode("span", {
            class: "gfu-field-toggle__icon",
            "data-selected": $options.valueAsString,
            "data-qa": "checkbox-field-icon"
          }, null, 8 /* PROPS */, _hoisted_3),
          _withDirectives(_createElementVNode("span", _hoisted_4, [
            _withDirectives(_createElementVNode("em", null, "*", 512 /* NEED_PATCH */), [
              [_vShow, $options.shouldShowRequiredIndicator]
            ]),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createElementVNode("span", null, [
              _createElementVNode("span", {
                "data-qa": `checkbox-name:${$props.checkedValue}`
              }, [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                  _createTextVNode(_toDisplayString($props.displayName), 1 /* TEXT */)
                ]),
                _renderSlot(_ctx.$slots, "additional-content")
              ], 8 /* PROPS */, _hoisted_5)
            ])
          ], 512 /* NEED_PATCH */), [
            [_vShow, $props.condensed && $props.showLabel]
          ]),
          ($props.customLabelText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($props.customLabelText), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ], 10 /* CLASS, PROPS */, _hoisted_2)
      ], 2 /* CLASS */)
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["show-label"]))
}